// initial state
const state = {
	user: null,
	role: null
}

// getters
const getters = {
	user: state => state.user,
	role: state => state.role
}

// actions
const actions = {
	setRole ({ commit }, role) {
		console.log('setProfile role in Store', role)

		commit('setRole', role)
	},
	setUser ({ commit }, user) {
		console.log('setEmail in Profile Store', user)

		commit('setUser', user)
	},

	resetProfile ({ commit }) {
		console.log('reset in Profile Store')

		commit('reset')
	}
}

// mutations
const mutations = {
	setUser (state, user) {
		state.user = user
	},
	setRole (state, role) {
		state.user.role = role
	},
	reset (state) {
		state.user = null
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
